import PastImagesContent from './PastImagesContent';

export default PastImagesContent;
